<template>
  <div class="wl-lead-form">
    <form
      class="wl-lead-form__wrapper"
      @submit.prevent="handleSubmit"
      method="POST"
      autocomplete="on"
    >
      <div class="wl-lead-form__form-group" v-if="!hideNameFields">
        <label for="first-name" class="wl-lead-form__label">first name</label>
        <input
          type="text"
          name="firstName"
          id="first-name"
          v-model.trim="firstName"
          placeholder="First Name"
          class="wl-lead-form__input-field"
          :class="
            error.firstName && (firstName === '' || firstName !== '')
              ? 'wl-lead-form__input-field--invalid'
              : (!error.firstName || error.firstName) && firstName === ''
              ? ''
              : 'wl-lead-form__input-field--valid'
          "
          @blur="handleBlur"
          @input="onFirstNameInput"
        />
      </div>
      <div class="wl-lead-form__form-group" v-if="!hideNameFields">
        <label for="last-name" class="wl-lead-form__label">last name</label>
        <input
          type="text"
          name="lastName"
          id="last-name"
          v-model.trim="lastName"
          placeholder="Last Name"
          class="wl-lead-form__input-field"
          :class="
            error.lastName && (lastName === '' || lastName !== '')
              ? 'wl-lead-form__input-field--invalid'
              : (!error.lastName || error.lastName) && lastName === ''
              ? ''
              : 'wl-lead-form__input-field--valid'
          "
          @blur="handleBlur"
          @input="onLastNameInput"
        />
      </div>
      <div class="wl-lead-form__form-group wl-lead-form__form-group--email">
        <label for="email-address" class="wl-lead-form__label"
          >email address</label
        >
        <input
          type="email"
          name="email"
          id="email-address"
          v-model="email"
          placeholder="Email Address"
          class="wl-lead-form__input-field"
          :class="
            error.email && (email !== '' || email === '')
              ? 'wl-lead-form__input-field--invalid'
              : (!error.email || error.email) && email === ''
              ? ''
              : 'wl-lead-form__input-field--valid'
          "
          @blur="handleBlur"
          @input="onEmailInput"
        />
      </div>
      <div class="wl-lead-form__button-wrapper">
        <button class="wl-lead-form__button">
          <span class="wl-lead-form__button-text">{{ buttonText }}</span>
          <img
            :src="buttonIcon"
            alt=""
            loading="lazy"
            class="wl-lead-form__button-text-icon"
          />
        </button>
        <p class="wl-lead-form__member-text">
          {{ memberText }}{{ ' ' }}
          <a :href="signInLink" :target="target" class="wl-lead-form__link">{{
            signInText
          }}</a>
        </p>
      </div>
    </form>
    <div class="wl-lead-form__disclaimer">
      <p class="wl-lead-form__disclaimer-text">{{ disclaimerText }}</p>
      <slot name="trustmark"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WlLeadForm',
  props: {
    buttonText: {
      type: String,
      required: true
    },
    memberText: {
      type: String
    },
    signInText: {
      type: String
    },
    signInLink: {
      type: String
    },
    target: {
      type: String,
      default: '_self'
    },
    disclaimerText: {
      type: String,
      required: true
    },
    buttonIcon: {
      type: String
    },
    hideNameFields: {
      type: Boolean,
      default: false
    },
    defaultFirstName: {
      type: String,
      default: 'Excuse'
    },
    defaultLastName: {
      type: String,
      default: 'Me'
    }
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      error: {
        firstName: false,
        lastName: false,
        email: false
      }
    };
  },
  methods: {
    handleBlur(event) {
      const fieldName = event.target.name;
      if (fieldName === 'firstName') {
        if (this.firstName === '') {
          this.error.firstName = true;
        }
      }
      if (fieldName === 'lastName') {
        if (this.lastName === '') {
          this.error.lastName = true;
        }
      }
      if (fieldName === 'email') {
        if (this.email === '') {
          this.error.email = true;
        }
      }
    },
    onFirstNameInput() {
      if (this.firstName) {
        this.error.firstName = !this.validName(this.firstName);
      } else {
        this.error.firstName = false;
      }
    },
    onLastNameInput() {
      if (this.lastName) {
        this.error.lastName = !this.validName(this.lastName);
      } else {
        this.error.lastName = false;
      }
    },
    onEmailInput() {
      if (this.email) {
        this.error.email = !this.validEmail(this.email);
      } else {
        this.error.email = false;
      }
    },
    validEmail(email) {
      const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      return emailRegex.test(email);
    },
    validName(name) {
      const regex = /^[A-Za-z]+$/;
      return regex.test(name);
    },
    handleSubmit() {
      if (this.hideNameFields) {
        this.firstName = this.defaultFirstName;
        this.lastName = this.defaultLastName;
      }
      this.error.firstName = !this.firstName || !this.validName(this.firstName);
      this.error.lastName = !this.lastName || !this.validName(this.lastName);
      this.error.email = !this.email || !this.validEmail(this.email);

      if (
        this.firstName &&
        this.lastName &&
        this.email &&
        !this.error.firstName &&
        !this.error.lastName &&
        !this.error.email
      ) {
        this.$emit('wl-lead-form-submit', {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email
        });
      } else {
        console.error('Form is invalid');
      }
    }
  }
};
</script>
